import { render, staticRenderFns } from "./CaseProject.vue?vue&type=template&id=065a18f7&scoped=true"
import script from "./CaseProject.vue?vue&type=script&lang=js"
export * from "./CaseProject.vue?vue&type=script&lang=js"
import style0 from "./CaseProject.vue?vue&type=style&index=0&id=065a18f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a18f7",
  null
  
)

export default component.exports